type PlayerItem = {
  type: "brightcove" | "beyondwords";
  pause: () => void;
  id: string;
};

class MediaController {
  private activePlayer: PlayerItem | null = null;

  register(player: PlayerItem) {
    return {
      onPlay: () => {
        if (this.activePlayer && this.activePlayer !== player) {
          try {
            this.activePlayer.pause();
          } catch (err) {
            console.warn(
              "[mediaController] Failed to pause active player:",
              err,
            );
          }
        }
        this.activePlayer = player;
        window.dispatchEvent(
          new CustomEvent("pauseAllPlayers", {
            detail: { sourceId: player.id },
          }),
        );
      },
      onPause: () => {
        if (this.activePlayer === player) {
          this.activePlayer = null;
        }
      },
    };
  }
}

export default new MediaController();
